import api from "../../../../utils/api";

const LeadApi = {
  // get all leads
  async fetchLeads(params = {}) {
    const { queryString, queryParams, signal, ...restParams } = params; // Ignore unwanted params
    const response = await api.get(
      `/profiling-form?${queryString}&${queryParams}`,
      {
        params: restParams,
        signal,
      }
    );
    return { data: response?.data };
  },

  // get lead by id
  async fetchLead(leadId, params = {}) {
    const response = await api.get(`/profiling-form/${leadId}`, { params });
    return response?.data?.data;
  },

  // add a lead
  async addLead(leadData) {
    const response = await api.post("/profiling-form", leadData);

    return response?.data;
  },

  async getFinencialPlanningPdfForEnrollment(id) {
    const response = await api.get(
      `/profiling-form/generate-financial-report-pdf/${id}`,
      {
        responseType: "blob",
      }
    );
    return response.data;
  },

  // fetchLeadsWithQuery for leads dashboard
  async fetchLeadsWithQuery(params = {}) {
    const { queryKey, signal, ...restParams } = params; // Ignore unwanted params
    const response = await api.get("/analytics/lead", {
      params: restParams,
      signal,
    });
    return { data: response?.data };
  },
};

export default LeadApi;
